import { createReducer, on, Action } from '@ngrx/store';
import { IArchiveRequest, IArchiveRequestList } from '../../../models/archive-request';
import { IDjangoErrors } from '../../../models/DjangoErrors';
import { ArchiveRequestApiActions, ArchiveRequestUiActions } from '../actions';

export const archiveRequestFeatureKey = 'archiveRequest';

export interface State {
  requests: IArchiveRequestList[];
  archiveRequestDetail: IArchiveRequest | null;
  myRequests: IArchiveRequestList[];
  pendingApprovals: IArchiveRequestList[];
  selectedRequestId: number | null;
  loading: boolean;
  error: IDjangoErrors | null;
}

export const initialState: State = {
  requests: [],
  archiveRequestDetail: null,
  myRequests: [],
  pendingApprovals: [],
  selectedRequestId: null,
  loading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(ArchiveRequestUiActions.loadArchiveRequests, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ArchiveRequestApiActions.loadArchiveRequestsSuccess, (state, { requests }) => ({
    ...state,
    requests,
    loading: false,
  })),
  on(ArchiveRequestApiActions.loadArchiveRequestsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ArchiveRequestUiActions.loadMyArchiveRequests, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ArchiveRequestApiActions.loadMyArchiveRequestsSuccess, (state, { requests }) => ({
    ...state,
    myRequests: requests,
    loading: false,
  })),
  on(ArchiveRequestApiActions.loadMyArchiveRequestsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ArchiveRequestUiActions.loadPendingApprovals, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ArchiveRequestApiActions.loadPendingApprovalsSuccess, (state, { requests }) => ({
    ...state,
    pendingApprovals: requests,
    loading: false,
  })),
  on(ArchiveRequestApiActions.loadPendingApprovalsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ArchiveRequestApiActions.loadArchiveRequestDetailsSuccess, (state, { request }) => ({
    ...state,
    archiveRequestDetail: request,
  })),
  on(ArchiveRequestApiActions.loadArchiveRequestDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export function ArchiveRequestReducer(state: State = initialState, action: Action): State {
  return reducer(state, action);
}
